import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the BacklistProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BacklistProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello BacklistProvider Provider');
  }

  getBlacklist(page,pagesize){
    let params = {
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/blacklist/get_list_by_client_id',params);
  }
  deleteBlacklist(rule_id,page,pagesize){
    let params = {
      rule_id:rule_id,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/blacklist/delete',params);
  }
  batchDelete(rule_list,page,pagesize){
    let params = {
      rule_id_list:rule_list.map(rule => rule.rule_id),
      page:page,
      pagesize:pagesize
    }
    return this.http.hPost('/blacklist/delete_batch',params);
  }

  getMember(chatroomname,keyword,page,pagesize){
    let params = {
      chatroomname:chatroomname,
      keyword:keyword,
      page:page,
      pagesize:pagesize
    };
    let url = 'get_member_list_by_chatroomname';
    if(keyword){
      url = 'search';
    }
    return this.http.hPost('/blacklist/'+url,params);
  }

  modifyBlack(member_list){
    let params = {
      add_list:member_list.map(member => member.username)
    };
    return this.http.hPost('/blacklist/modify_manual',params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/backlist/backlist.ts